import React, { Component } from 'react';
import { Table, DatePicker, Select } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {values} from 'lodash';
import styled from 'styled-components';
import utils from '../../common/utils';
import moment from 'moment';
import consts from '../../consts'

const ChartWrapper = styled.div`
  padding: 16px;
  background: white;
  margin-bottom: 10px;
  &>div{
      width:100%;
      display:flex;
      justify-content:flex-end;
      margin-bottom:16px;
  }
  &>div>.ant-select {
      width: 300px;
  }
`;

Highcharts.setOptions({
    lang: {
        months: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
        ]
    }
});


const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker
const { Option } = Select;

class InOutTrans extends Component {
    getColumns = (t) => {
        return [
            {
                align: "center",
                title: "Đồng",
                dataIndex: "market",
                key: "market",
                width: 100,
            },
            {
                align: "center",
                title: "Số lượng giao dịch",
                dataIndex: "totalCount",
                key: "totalCount",
                width: 120,
                render: (count) => <div>{`${utils.formatCurrency(count || 0)}`}</div>
            },
            {
                align: "center",
                title: "Lượng nạp",
                dataIndex: 'total_amount_deposit',
                key: 'total_amount_deposit',
                width: 120,
                render: (totalAmountDeposit) => <div>{`${utils.formatCurrency(totalAmountDeposit || 0)}`}</div>
            },
            {
                align: "center",
                title: "Lượng phí nạp",
                dataIndex: "Lượng phí nạp",
                key: "total_fee_deposit",
                width: 120,
                render: (totalFeeDeposit) => <div>{`${utils.formatCurrency(totalFeeDeposit || 0)}`}</div>
            },
            {
                align: "center",
                title: "Lượng rút",
                dataIndex: 'total_amount_withdraw',
                key: 'total_amount_withdraw',
                width: 120,
                render: (totalAmountWithdraw) => <div>{`${utils.formatCurrency(totalAmountWithdraw || 0)}`}</div>
            },
            {
                align: "center",
                title: "Lượng phí rút",
                dataIndex: "total_fee_withdraw",
                key: "total_fee_withdraw",
                width: 120,
                render: (totalFeeWithdraw) => <div>{`${utils.formatCurrency(totalFeeWithdraw || 0)}`}</div>
            },
        ]
    }

    constructor(props) {
        super(props)
        this.state = {
            inOutTrans: [],
            statisticDate: {},
        };
        this.filter = {
            begin: moment().subtract(7, 'days').unix(),
            end: moment().unix(),
        };
        this.coinFilter = {
            coin: 'ETH',
        }
    }

    componentDidMount() {
        this.props.onFetchInOutTransAction()
        this.props.onFetchInOutTransChartAction({...this.filter,...this.coinFilter})

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!!nextProps) {
            this.setState({
                inOutTrans: nextProps.inOutTrans,
                statisticDate: nextProps.statisticDate
            })
        }
    }

    disabledDate(current) {
        return current && current > moment().endOf('day');
    }

    onChangeDate = (current) => {
        if (current) {
            this.filter = {
                ...this.filter,
                begin: current[0].startOf('day').unix(),
                end: current[1].endOf('day').unix(),
            }
        }
        else {
            this.filter = {
                ...this.filter,
                begin: '',
                end: '',
            }
        }
        this.props.onFetchInOutTransAction(this.filter);
        this.props.onFetchInOutTransChartAction({...this.filter,...this.coinFilter})
    }

    onMarketChange = (value) => {
        this.coinFilter = {
            coin: values(this.props.coins)[value].symbol,
        }
        this.props.onFetchInOutTransChartAction({...this.filter,...this.coinFilter})
    }

    render() {
        const { inOutTrans, statisticDate } = this.state
        return (
            <div className="withdrawalHistory mr-medium ml-medium" >
                <h3>Thông tin giao dịch</h3>
                <div className="d-flex">
                    <RangePicker
                        disabledDate={this.disabledDate}
                        format={dateFormat}
                        onChange={this.onChangeDate}
                        locale={consts.LangDateVi}
                        defaultValue={[moment.unix(this.filter.begin), moment.unix(this.filter.end)]}
                    />
                </div>

                <div className='mt-medium table-width-large'>
                    <ChartWrapper>
                        <div>
                            <Select
                                onChange={this.onMarketChange}
                                defaultValue={'ETH'}
                            >
                                {values(this.props.coins).map((item, index) => (
                                    <Option value={index}>
                                        {`${item.symbol}`}
                                    </Option>   
                                ))}
                            </Select>
                        </div>
                        <HighchartsReact highcharts={Highcharts} options={{
                            chart: {
                                type: 'spline'
                            },

                            title: {
                                text: this.props.name
                            },
                            xAxis: {
                                type: 'datetime',
                                labels: {
                                    format: "{value:%e/%B/%Y}",
                                },
                            },
                            yAxis: {
                            },
                            series: [
                                {
                                    name: "Tổng nạp",
                                    data: (this.props.inOutTransChart[0] || []).map((item) => ([item.time_stamp * 1000, item.total_amount]))
                                },
                                {
                                    name: "Tổng phí nạp",
                                    data: (this.props.inOutTransChart[0] || []).map((item) => ([item.time_stamp * 1000, item.total_fee]))
                                },
                                {
                                    name: "Tổng lệnh nạp",
                                    data: (this.props.inOutTransChart[0] || []).map((item) => ([item.time_stamp * 1000, item.total_count]))
                                },
                                {
                                    name: "Tổng rút",
                                    data: (this.props.inOutTransChart[1] || []).map((item) => ([item.time_stamp * 1000, item.total_amount]))
                                },
                                {
                                    name: "Tổng phí rút",
                                    data: (this.props.inOutTransChart[1] || []).map((item) => ([item.time_stamp * 1000, item.total_fee]))
                                },
                                {
                                    name: "Tổng lệnh rút",
                                    data: (this.props.inOutTransChart[1] || []).map((item) => ([item.time_stamp * 1000, item.total_count]))
                                },
                            ]
                        }} />
                    </ChartWrapper>
                    <Table dataSource={inOutTrans}
                        columns={this.getColumns()}
                        bordered
                        pagination={{
                            hideOnSinglePage: true,
                        }} />
                </div>
            </div>
        )
    }
}

export default InOutTrans;
